import Cookies from 'js-cookie'
import api from '../api'
import router from '@/router'

export const state = {
	loading: false,

	signInError: {},

	signUpError: {},
	signUpSuccess: false,

	forgotPassResult: '',

	changePassError: '',
	changePassSuccess: false,

	linkExpirationMessage: '',

	user: null,
	token: Cookies.get('token')
}

export const mutations = {
	SET_LOADING (state, payload) {
		this._vm.$set(state, 'loading', payload)
	},

	SET_USER (state, payload) {
		this._vm.$set(state, 'user', payload)
	},

	SET_TOKEN (state, payload) {
		this._vm.$set(state, 'token', payload)
	},

	SET_SIGN_IN_ERROR (state, payload) {
		this._vm.$set(state, 'signInError', payload)
	},

	SET_SIGN_UP_SUCCESS (state, payload) {
		this._vm.$set(state, 'signUpSuccess', payload)
	},

	SET_SIGN_UP_ERROR (state, payload) {
		this._vm.$set(state, 'signUpError', payload)
	},

	SET_FORGOT_PASS_RESULT (state, payload) {
		this._vm.$set(state, 'forgotPassResult', payload)
	},

	SET_CHANGE_PASS_SUCCESS (state, payload) {
		this._vm.$set(state, 'changePassSuccess', payload)
	},

	SET_CHANGE_PASS_ERROR (state, payload) {
		this._vm.$set(state, 'changePassError', payload)
	},

	SET_LINK_EXPIRATION_MESSAGE (state, payload) {
		this._vm.$set(state, 'linkExpirationMessage', payload)
	}
}

export const actions = {
	async fetchUser ({ commit }) {
		commit('SET_LOADING', true)
		const { data, status } = await api('get', '/insight/client/fetch-user')

		if (status) {
			commit('SET_USER', data.data)
			commit('SET_LOADING', false)
			return
		}

		commit('SET_USER', null)
		commit('SET_TOKEN', null)
		Cookies.remove('token')
		commit('SET_LOADING', false)
	},

	async signIn ({ commit }, payload) {
		commit('SET_LOADING', true)
		const { data, message, error, status } = await api('post', '/insight/authenticate/login', payload)

		if (status) {
			Cookies.set('token', data.data.api_token, { expires: 36500 })
			commit('SET_TOKEN', data.data.api_token)
			location.reload()
			return
		}

		// check if error is empty
		// if error is empty display the message property
		// else set the error response
		if (Object.keys(error).length === 0) commit('SET_SIGN_IN_ERROR', message || 'Something went wrong')
		else commit('SET_SIGN_IN_ERROR', error)

		if (message === 'Your account subscription is over, please contact support@upmood.com to renew your license') {
			commit('SET_SIGN_IN_ERROR', message || 'Something went wrong')
		}

		commit('SET_USER', null)
		Cookies.remove('token')
		commit('SET_LOADING', false)
	},

	async signUp ({ commit }, payload) {
		commit('SET_LOADING', true)
		payload.commit = commit
		const { error, status } = await api('post', '/insight/authenticate/signup', payload)

		if (status) {
			commit('SET_SIGN_UP_SUCCESS', true)
			commit('SET_LOADING', false)
		    commit('clearSignUp', null, { root: true })
			router.push({ path: '/signup-success' })
			return
		}

		commit('SET_SIGN_UP_ERROR', error)
		commit('SET_LOADING', false)
	},

	async forgotPassword ({ commit }, payload) {
		commit('SET_LOADING', true)
		const { data, status } = await api('post', '/insight/authenticate/forgot-password', payload)

		if (status) {
			commit('SET_FORGOT_PASS_RESULT', 'success')
		    commit('SET_LOADING', false)
			return
		}

		commit('SET_FORGOT_PASS_RESULT', data.message)
		commit('SET_LOADING', false)
	},

	async changePassword ({ commit }, payload) {
		commit('SET_LOADING', true)
		const { data, error, status } = await api('post', '/insight/authenticate/change-password', payload)

		if (status) {
			commit('SET_CHANGE_PASS_SUCCESS', true)
			commit('SET_LOADING', false)
			router.push({ name: 'change-password-success' })
			return
		}

		commit('SET_CHANGE_PASS_SUCCESS', false)
		commit('SET_CHANGE_PASS_ERROR', error || data.message)
		commit('SET_LOADING', false)
	},

	async verify ({ commit }, payload) {
		const { status } = await api('post', '/insight/authenticate/verify', payload)
		return status
	},

	async checkLinkExpiration ({ commit }, payload) {
		commit('SET_LOADING', true)
		const { status } = await api('post', '/insight/authenticate/check-token', payload)

		commit('SET_LOADING', false)
		return status
	},

	async checkEmail ({ commit }, payload) {
		commit('SET_LOADING', true)
		const { status } = await api('post', '/insight/authenticate/check-email', payload)

		commit('SET_LOADING', false)
		return status
	},

	async signOut ({ commit }) {
		await api('post', '/insight/authenticate/logout')
		commit('SET_USER', null)
		commit('SET_TOKEN', null)
		Cookies.remove('token')
		location.reload()
	}
}

export const getters = {
	// getUser: state => state.user,
	// token: state => state.token,
	getLoggedInState: state => state.user !== null,
	isUserSolution: state => state.user.company_type === 'School'
}



// WEBPACK FOOTER //
// ./src/store/global/auth.js